import { Injectable, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(
    private modalService: BsModalService
  ) { }

  show<T = Record<string, any>>(
    component: string | TemplateRef<any> | { new(...args: any[]): T; },
    modalConfig: ModalOptions<T>
  ): BsModalRef<T> {
    const defaultModalConfig = {
      ignoreBackdropClick: true
    };

    return this.modalService.show(component, { ...defaultModalConfig, ...modalConfig });
  }
}
